import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function useGetSignedPhysicianEICFConsents() {
  const { currentUser } = useSessionProvider();
  const facilityId = currentUser?.selectedHealthcareFacilityID;

  return useQuery({
    queryKey: [QueryKeys.eicfSignedPhysicianConsents, facilityId],
    queryFn: () => EICFConsentsApi.getSignedForPhysician(facilityId),
  });
}
